import { TILE, W, H, FUSE_TICKS } from '../core/constants';
import { Cell } from './grid';
import { FlameKind } from './bombs';
const PICKUP_PALETTE = {
    fire: { bg: '#5a2020', fg: '#ff8030', label: 'F' },
    bomb: { bg: '#202020', fg: '#e0e0e0', label: 'B' },
    speed: { bg: '#205a20', fg: '#80ff80', label: 'S' },
    wall_pass: { bg: '#5a3a10', fg: '#ffd070', label: 'W' },
    bomb_pass: { bg: '#202050', fg: '#80a0ff', label: 'P' },
    flame_pass: { bg: '#502020', fg: '#ff5050', label: 'L' },
    remote: { bg: '#4a205a', fg: '#d080ff', label: 'R' },
    kick: { bg: '#205a5a', fg: '#80f0e0', label: 'K' },
};
export class Renderer {
    ctx;
    constructor(canvas) {
        const ctx = canvas.getContext('2d');
        if (!ctx)
            throw new Error('2D canvas not available');
        ctx.imageSmoothingEnabled = false;
        this.ctx = ctx;
    }
    draw(world) {
        this.ctx.clearRect(0, 0, W, H);
        this.drawGrid(world.grid);
        if (world.exit)
            this.drawExit(world.exit);
        for (const p of world.pickups)
            this.drawPickup(p);
        for (const b of world.bombs)
            this.drawBomb(b);
        for (const f of world.flames)
            this.drawFlame(f);
        for (const e of world.enemies)
            this.drawEnemy(e);
        this.drawPlayer(world.player);
        this.drawHud(world);
    }
    drawGrid(grid) {
        const ctx = this.ctx;
        for (let r = 0; r < grid.rows; r++) {
            for (let c = 0; c < grid.cols; c++) {
                const x = c * TILE;
                const y = r * TILE;
                const t = grid.get(c, r);
                if (t === Cell.Floor) {
                    ctx.fillStyle = '#1f5d2c';
                    ctx.fillRect(x, y, TILE, TILE);
                    ctx.fillStyle = '#26763a';
                    for (let i = 0; i < 4; i++) {
                        const px = x + ((c * 7 + r * 3 + i * 11) % TILE);
                        const py = y + ((c * 13 + r * 5 + i * 17) % TILE);
                        ctx.fillRect(px, py, 2, 2);
                    }
                }
                else if (t === Cell.HardBlock) {
                    ctx.fillStyle = '#3a3a3a';
                    ctx.fillRect(x, y, TILE, TILE);
                    ctx.fillStyle = '#5a5a5a';
                    ctx.fillRect(x + 3, y + 3, TILE - 6, TILE - 6);
                    ctx.fillStyle = '#2a2a2a';
                    ctx.fillRect(x, y, TILE, 2);
                    ctx.fillRect(x, y + TILE - 2, TILE, 2);
                    ctx.fillRect(x, y, 2, TILE);
                    ctx.fillRect(x + TILE - 2, y, 2, TILE);
                }
                else {
                    // SoftBlock
                    ctx.fillStyle = '#1f5d2c';
                    ctx.fillRect(x, y, TILE, TILE);
                    ctx.fillStyle = '#a35a2a';
                    ctx.fillRect(x + 2, y + 2, TILE - 4, TILE - 4);
                    ctx.fillStyle = '#7a4020';
                    for (let by = 0; by < 2; by++) {
                        const offY = y + 2 + by * Math.floor((TILE - 4) / 2);
                        const offX = x + 2 + (by % 2) * 4;
                        for (let bx = 0; bx < 3; bx++) {
                            ctx.fillRect(offX + bx * 9, offY, 8, Math.floor((TILE - 4) / 2) - 1);
                        }
                    }
                }
            }
        }
    }
    drawExit(exit) {
        const ctx = this.ctx;
        const x = exit.col * TILE, y = exit.row * TILE;
        // постамент
        ctx.fillStyle = '#202020';
        ctx.fillRect(x + 2, y + 2, TILE - 4, TILE - 4);
        // двері
        ctx.fillStyle = '#7a4a20';
        ctx.fillRect(x + 6, y + 4, TILE - 12, TILE - 8);
        // ручка
        ctx.fillStyle = '#ffd070';
        ctx.fillRect(x + TILE - 12, y + Math.floor(TILE / 2) - 1, 3, 3);
        // мигання
        const t = (performance.now() / 600) % 1;
        ctx.fillStyle = `rgba(255,255,200,${0.3 + 0.3 * Math.sin(t * Math.PI * 2)})`;
        ctx.fillRect(x + 6, y + 4, TILE - 12, 2);
    }
    drawPickup(p) {
        const ctx = this.ctx;
        const x = p.col * TILE, y = p.row * TILE;
        const palette = PICKUP_PALETTE[p.kind];
        const cx = x + TILE / 2, cy = y + TILE / 2;
        // м'яка пульсація
        const t = (performance.now() / 500) % 1;
        const r = TILE * 0.32 + Math.sin(t * Math.PI * 2) * 1.5;
        ctx.fillStyle = palette.bg;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = palette.fg;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.stroke();
        ctx.fillStyle = palette.fg;
        ctx.font = 'bold 14px ui-monospace, "SF Mono", Menlo, monospace';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(palette.label, cx, cy + 1);
    }
    drawBomb(b) {
        const ctx = this.ctx;
        const cx = b.x;
        const cy = b.y;
        const t = b.remote ? 0.3 : (FUSE_TICKS - b.fuse) / FUSE_TICKS;
        const pulse = 1 + 0.12 * Math.sin(t * t * 60);
        const r = TILE * 0.34 * pulse;
        ctx.fillStyle = '#1a1a1a';
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#444';
        ctx.beginPath();
        ctx.arc(cx - r * 0.35, cy - r * 0.35, r * 0.25, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = b.remote ? '#d080ff' : '#aa9020';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(cx, cy - r);
        ctx.quadraticCurveTo(cx + r * 0.5, cy - r * 1.4, cx + r * 0.7, cy - r * 1.6);
        ctx.stroke();
        if (!b.remote && (Math.floor(t * 30)) % 2 === 0) {
            ctx.fillStyle = '#ffcc44';
            ctx.beginPath();
            ctx.arc(cx + r * 0.7, cy - r * 1.6, 2, 0, Math.PI * 2);
            ctx.fill();
        }
    }
    drawFlame(f) {
        const ctx = this.ctx;
        const x = f.col * TILE;
        const y = f.row * TILE;
        const a = f.life / f.maxLife;
        ctx.fillStyle = `rgba(255,140,0,${0.85 * a})`;
        this.flameShape(x, y, f.kind, 0);
        ctx.fillStyle = `rgba(255,230,80,${0.95 * a})`;
        this.flameShape(x, y, f.kind, 6);
        if (a > 0.7) {
            ctx.fillStyle = `rgba(255,255,255,${(a - 0.7) / 0.3})`;
            this.flameShape(x, y, f.kind, 12);
        }
    }
    flameShape(x, y, kind, inset) {
        const ctx = this.ctx;
        const W2 = TILE - inset * 2;
        if (kind === FlameKind.Center) {
            ctx.fillRect(x + inset, y + inset, W2, W2);
        }
        else if (kind === FlameKind.Horizontal) {
            ctx.fillRect(x, y + inset, TILE, W2);
        }
        else if (kind === FlameKind.Vertical) {
            ctx.fillRect(x + inset, y, W2, TILE);
        }
        else if (kind === FlameKind.EndLeft) {
            ctx.fillRect(x + inset / 2, y + inset, TILE - inset / 2, W2);
        }
        else if (kind === FlameKind.EndRight) {
            ctx.fillRect(x, y + inset, TILE - inset / 2, W2);
        }
        else if (kind === FlameKind.EndUp) {
            ctx.fillRect(x + inset, y + inset / 2, W2, TILE - inset / 2);
        }
        else if (kind === FlameKind.EndDown) {
            ctx.fillRect(x + inset, y, W2, TILE - inset / 2);
        }
    }
    drawEnemy(e) {
        const ctx = this.ctx;
        const palette = e.kind === 'balloom' ? { body: '#d04a4a', accent: '#7a2020' }
            : e.kind === 'onil' ? { body: '#3aa3d0', accent: '#155a7a' }
                : { body: '#9a40d0', accent: '#4a1a7a' };
        ctx.fillStyle = 'rgba(0,0,0,0.35)';
        ctx.beginPath();
        ctx.ellipse(e.x, e.y + e.r * 0.7, e.r * 0.8, e.r * 0.35, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = palette.body;
        ctx.beginPath();
        ctx.arc(e.x, e.y, e.r, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = palette.accent;
        ctx.beginPath();
        ctx.arc(e.x, e.y + e.r * 0.4, e.r * 0.85, 0, Math.PI, false);
        ctx.fill();
        const ox = Math.sign(e.dir.dx) * 1.5;
        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.arc(e.x - e.r * 0.35, e.y - e.r * 0.15, e.r * 0.22, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.arc(e.x + e.r * 0.30, e.y - e.r * 0.15, e.r * 0.22, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#000';
        ctx.fillRect(Math.round(e.x - e.r * 0.35 + ox - 1), Math.round(e.y - e.r * 0.15 - 1), 2, 2);
        ctx.fillRect(Math.round(e.x + e.r * 0.30 + ox - 1), Math.round(e.y - e.r * 0.15 - 1), 2, 2);
    }
    drawPlayer(p) {
        const ctx = this.ctx;
        if (!p.alive)
            return;
        if (p.iframes > 0 && Math.floor(p.iframes / 4) % 2 === 0)
            return;
        ctx.fillStyle = 'rgba(0,0,0,0.35)';
        ctx.beginPath();
        ctx.ellipse(p.x, p.y + p.r * 0.7, p.r * 0.8, p.r * 0.35, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#e8e8e8';
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = '#356dd5';
        ctx.beginPath();
        ctx.arc(p.x, p.y + p.r * 0.4, p.r * 0.85, 0, Math.PI, false);
        ctx.fill();
        ctx.fillStyle = '#222';
        ctx.fillRect(Math.round(p.x - p.r * 0.45), Math.round(p.y - p.r * 0.2), 3, 3);
        ctx.fillRect(Math.round(p.x + p.r * 0.20), Math.round(p.y - p.r * 0.2), 3, 3);
    }
    drawHud(world) {
        const ctx = this.ctx;
        ctx.fillStyle = 'rgba(0,0,0,0.65)';
        ctx.fillRect(0, 0, W, 24);
        ctx.font = 'bold 13px ui-monospace, "SF Mono", Menlo, monospace';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'left';
        const stats = world.player.stats;
        let xCursor = 8;
        const seg = (txt, color = '#fff') => {
            ctx.fillStyle = color;
            ctx.fillText(txt, xCursor, 12);
            xCursor += ctx.measureText(txt).width + 12;
        };
        seg(`Lv ${world.config.id}${world.config.bonus ? '★' : ''}`, '#ffd070');
        seg(`♥ ${Math.max(0, world.player.lives + 1)}`);
        seg(`◎ ${world.enemies.length}`);
        seg(`Score ${world.carried.score}`);
        const t = world.secondsLeft();
        const tColor = t <= 10 ? '#ff5050' : (t <= 30 ? '#ffd070' : '#aaaaaa');
        seg(`⏱ ${t}s`, tColor);
        seg(`F${stats.range}`, '#ff8030');
        seg(`B${stats.maxBombs}`, '#cccccc');
        seg(`S${world.player.speed.toFixed(1)}`, '#80ff80');
        if (stats.wallPass)
            seg('W', '#ffd070');
        if (stats.bombPass)
            seg('P', '#80a0ff');
        if (stats.flamePass)
            seg('L', '#ff5050');
        if (stats.remote)
            seg('R', '#d080ff');
        if (stats.kick)
            seg('K', '#80f0e0');
        if (world.status !== 'playing') {
            ctx.fillStyle = 'rgba(0,0,0,0.7)';
            ctx.fillRect(0, 0, W, H);
            ctx.fillStyle = world.status === 'won' ? '#9ae66e' : '#e66e6e';
            ctx.font = 'bold 32px ui-monospace, "SF Mono", Menlo, monospace';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(world.status === 'won' ? 'STAGE CLEAR!' : 'GAME OVER', W / 2, H / 2 - 10);
            ctx.fillStyle = '#ddd';
            ctx.font = '14px ui-monospace, "SF Mono", Menlo, monospace';
            ctx.fillText('Натисніть R щоб почати знову', W / 2, H / 2 + 20);
        }
    }
}
